/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

import ApiService from "./ApiService";
import Feat from '../model/Feat';

class FeatService {
  static async fetchFeats(cacheOnly: boolean, progCallback: (data: any[], totalCount: number) => void): Promise<Ability[]> {
    try {
        const feats: Feat[] = await ApiService.getAllFeats(cacheOnly, progCallback);
        const abilities = [];
        for (const feat of feats) {
          // replace the \r\n in strings like:
          // 'your critical hit range\r\nfor that attack is increased by 1',
          // 'On a success, it takes half damage and is rattled until the end of its\r\nnext turn.',
          // ', and you regain the use of Charming Gaze when you finish any\r\nrest.',
          // 'and initiative checks made against creatures that are part of your\r\nvendetta,',
          // 'You learn this cantrip and your spellcasting ability for it depends\r\non the spell list you chose from:',
          // 'A\r\npowerful attack has disadvantage, but on a hit deals 10 extra damage.',
          // 'Unlike other\r\nattuned items, your attunement to this item doesn’t end from being more than',
          let desc = feat.desc.replace(/([A-Za-z])\r\n([A-Za-z])/g, '$1 $2');
          for (const ben of feat.benefits) {
              desc += '\n * ' + ben.desc;
          }
          
          const ability = {
            name: feat.name,
            label: feat.name,
            desc: desc,
            group: 'Feats'
          };
          abilities.push(ability);
          if (feat.has_prerequisite) {
            ability.desc += '\n****requires:*** *' + feat.prerequisite + '*';
            (ability as any).prerequisite = feat.prerequisite;
          }
        }
        return abilities;
    } catch (error) {
        console.error("Failed to fetch spells", error);
        return [];
    }
  }
}
export default FeatService;